const LOG_MIN = Math.log10(5)
const LOG_MAX = Math.log10(500000)

export const pos = (v: number): number =>
  Math.max(0, Math.min(100, ((Math.log10(Math.max(v, 1)) - LOG_MIN) / (LOG_MAX - LOG_MIN)) * 100))

export const fmtFull = (n: number): string => '€' + n.toLocaleString('en-US')

export const fmtShort = (n: number): string => {
  if (n >= 1000) {
    const k = n / 1000

    let formatted: string

    if (k >= 10) {
      formatted = Math.round(k).toString()
    } else {
      formatted = k.toFixed(1).replace(/\.0$/, '')
    }

    return '€' + formatted + 'K'
  }

  return '€' + n
}

export const TICKS = [10, 100, 1000, 10000, 100000] as const
